<template>
  <div>
    <b-row>
      <div class="col-md-offset-4 col-md-4">
        <h1>Authentification</h1>
        <p>Bienvenu sur MACS GDPR, votre compte est validé !</p>
        <b-button @click="toHome()" varian="main">Se connecter</b-button>
      </div>
    </b-row>
  </div>
</template>


<script>
import Vue from "vue";
import Vuex from "vuex";
import router from "../router/index.js";

export default {
  async mounted() {
    let token = this.$route.params.token;
    // Vue.axios.defaults.headers.common["Authorization"] = "Bearer " + this.token;
    await this.checkAccount(token);
    router.push({ path: "/login" });
  },
  name: "EmailValidation",
  methods: {
    toHome() {
      router.push({ path: "/login" });
    },
    ...Vuex.mapActions("User", ["checkAccount"]),
  },
  computed: {},

  data: () => ({
    token: "",
  }),
};
</script>
